import React from 'react'

import ButtonLink from '@aletheia/common/components/ButtonLink'

import { Grant, GrantRow, fundSlugs } from '../../pages/grants'

export const HighlightedGrants = ({
  grants,
  fundSlug,
}: {
  grants: Grant[]
  fundSlug: string
}) => {
  const filter = Object.keys(fundSlugs).find(
    (fundName) => fundSlugs[fundName] === fundSlug,
  )
  return (
    <>
      {grants.map((grant) => (
        <GrantRow key={grant.id} grant={grant} omitFundLabel />
      ))}
      <ButtonLink
        variant="outlined"
        href={`/grants?fund=${encodeURIComponent(filter as string)}`}
      >
        View more {filter} grants
      </ButtonLink>
    </>
  )
}
